export default __webpack_public_path__ + "static/media/etapa6.7ef22bd4.png";